export default __webpack_public_path__ + "static/media/offer_db_preview.ce4786cd.png";